import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Loader, Form, DropdownProps, Label, Icon, Segment } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import DebtsRepository, { IDebtor, IDebtorParams } from "../../Repositories/DebtorRepository";
import NumberFormat from "../../Utils/NumberFormat";
import EditarKit from "../Kits/EditarKit";
import CustomLoader from "../../components/CustomLoader";

const Prevision: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IDebtor[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IDebtorParams>({ year: date.getFullYear().toString(), month: (date.getMonth() + 1).toString() });

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsYear = [
        { key: "1", text: "2020", value: "2020" },
        { key: "2", text: "2021", value: "2021" },
        { key: "3", text: "2022", value: "2022" },
        { key: "4", text: "2023", value: "2023" },
        { key: "5", text: "2024", value: "2024" },
        { key: "6", text: "2025", value: "2025" },
        { key: "7", text: "2026", value: "2026" },
    ];

    const load = async () => {

        setLoading(true);
        try {

            const response = await DebtsRepository.Debts({
                year: state.year,
                month: state.month
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    useEffect(() => { load() }, []);

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }
    const setProtestado = (protestado: boolean, devedor: number) => {
        if (protestado === true && devedor === 1) {
            return <Label ribbon icon="check" color="green" content="SIM" />            
        }
        if (protestado === false && devedor === 1) {
            return <Label ribbon icon="times" color="red" content="NÃO" />
        }
        if (devedor === 2) {
            return <Label ribbon icon="thumbs up" color="orange" content="NEG" />
        }
        else{
            return <Label ribbon icon="dont" color="grey" content="S/R" />
        }
    }

    const setFicha = (ficha: boolean, kit: number) => {
        if (ficha === true) {
            return <Label icon="check circle" color="green" content={kit} />
        }
        else {
            return <Label icon="times circle" color="red" content={kit} />            
        }
    }

    const setCrm = (revCrm: string) => {
        if (revCrm) {
            return <Icon color="orange" size="large" name='warning sign' />
        }
    }
    
    const tableRender: ITableAppRender[] = [
        {
            header: "Protesto",
            content: (x: IDebtor) => setProtestado(x.protestado, x.devedor),
            textAlign: "left",
            width: 1
        },
        {
            header: "G. Setor",
            content: (x: IDebtor) => x.gerente,
            textAlign: "left",
            width: 3
        },
        {
            header: "Representante",
            content: (x: IDebtor) => x.representante,
            textAlign: "left",
            width: 3
        },
        {
            header: "Revendedor",
            content: (x: IDebtor) => x.revendedor,
            textAlign: "left",
            width: 3
        },
        {
            header: "Kit",
            content: (x: IDebtor) => setFicha(x.ficha, x.kit),
            textAlign: "center",
            width: 2
        },
        {
            header: "Venda",
            content: (x: IDebtor) => NumberFormat.Currency(x.valorVendido),
            textAlign: "left",
            width: 1
        },
        {
            header: "Receber",
            content: (x: IDebtor) => NumberFormat.Currency(x.valorReceber),
            textAlign: "center",
            width: 1
        },
        {
            header: "Recebido",
            content: (x: IDebtor) => NumberFormat.Currency(x.valorRecebido),
            textAlign: "center",
            width: 1
        },
        {
            header: "Debito",
            content: (x: IDebtor) => NumberFormat.Currency(x.valorDebito),
            textAlign: "center",
            width: 1
        },
        {
            header: "",
            content: (x: IDebtor) => setCrm(x.revCrm),
            textAlign: "center",
            width: 1
        },
        {
            header: "",
            content: (x: IDebtor) => <EditarKit key={`kits_edit_${x.kitId}`} kitId={ x.kitId || ""} onSuccess={load} />,
            textAlign: "center",
            width: 1
        }
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Revendedores Devedores`} icon="remove user" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="month"
                                                placeholder="Selecione o mês"
                                                label="Mês"
                                                options={optionsMonth}
                                                value={state.month}
                                                onChange={onDropdownChange}

                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default Prevision;
